import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
} from '@mui/material';
import Footer from '../navbar/Footer';

const bulletins = [
  {
    title: "Bulletin d’information : Deuxième Trimestre 2023-2024",
    description: "La Direction Générale de l’Institut National de la Statistique du Burundi présente la NewsStat pour le deuxième trimestre 2023-2024 (octobre à décembre 2023).",
    link: "/documents/NewsStats/NewsStat_Trimestre-2_VF_Fevrier_2024.pdf",
  },
  {
    title: "Bulletin d’information : Premier Trimestre 2023-2024",
    description: "La Direction Générale de l’Institut National de la Statistique du Burundi annonce la publication de la NewsStat pour le premier trimestre 2023-2024.",
    link: "/documents/NewsStats/NEWSSTAT-BOUCLE_VF_13.11.2023_A-Imprimer-1-1.pdf",
  },
  {
    title: "Bulletin d’information : Deuxième Trimestre de l’année 2017",
    description: "L'Institut de Statistiques et d'Études Economiques du Burundi (ISTEEBU) présente son deuxième bulletin d'information statistique, « La NewsStat Burundi ». Ce bulletin se concentre sur les réalisations statistiques du 2ème trimestre 2017 et l'implication de l'ISTEEBU sur l'échiquier international, régional et sous-régional.",
    link: "/documents/NewsStats/NEWSSTAT-B-N.2-B1-Vrai-au-16.08.2017.pdf", 
  },
  {
    title: "Bulletin d’information : Premier Trimestre de l’année 2017",
    description: "L’Institut de Statistiques et d’Etudes Economiques du Burundi (ISTEEBU) lance son premier bulletin d’information, « La NewsStat Burundi », qui a pour objectif d'informer le public sur les activités du Système Statistique National (SSN).",
    link: "/documents/NewsStats/NewsStat-Burundi-N0-1-avril.pdf", 
  }
];

function RapportProjectPopulation(){
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
      <NavigationBar />
      <Container maxWidth="lg">
        <Typography variant="h2" align="center" gutterBottom style={{ color: 'green' }}>
          NewsStat du Burundi
        </Typography>
        <Typography variant="h6" align="center" gutterBottom>
          Restez à jour avec les dernières statistiques !
        </Typography>
        <Typography variant="body1" align="center" paragraph>
          Bienvenue sur la page NewsStat, votre source essentielle pour accéder aux dernières actualités et analyses statistiques concernant le Burundi. Notre objectif est de fournir une rétrospective complète et objective des données macroéconomiques et sociales, vous permettant ainsi de mieux comprendre les tendances qui façonnent notre pays. Découvrez nos bulletins d'information couvrant différents trimestres et thèmes essentiels pour les chercheurs, les décideurs, et le grand public.
        </Typography>
        <Grid container spacing={4} style={{ marginTop: '40px' }}>
          {bulletins.map((bulletin, index)=>(
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h5" component="div">
                    {bulletin.title}
                  </Typography>
                  <Typography variant="body2" component="div">
                    {bulletin.description}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    variant="contained"
                    style={{ backgroundColor: 'green', color: 'white' }}
                    href={bulletin.link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                  >
                   {<DownloadIcon />} Télécharger
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default RapportProjectPopulation;